import React, { useRef } from "react";

export default function KilometerInput({ kilometers, onChange, disabled }) {
    const [displayValue, setDisplayValue] = React.useState("");
    const inputRef = useRef(null);

    const handleChange = (event) => {
        const newDisplayValue = event.target.value;
        // Allow only numbers and spaces (for formatting)
        const filteredDisplayValue = newDisplayValue.replace(/[^0-9]/g, "");

        // Format with spaces for display (French thousand separator)
        const formatted = filteredDisplayValue.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        setDisplayValue(formatted);

        // Pass numeric value to parent
        onChange(Number(filteredDisplayValue) || 0);
    };

    return (
        <div
            className={`${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-text'}`}
            onClick={() => !disabled && inputRef.current && inputRef.current.focus()}
        >
            <div
                className="text-sm sm:text-base mb-2 cursor-default"
                id="kmLabel"
            >
                Kilométrage annuel parcouru
            </div>
            <div className="flex items-center gap-2">
                <input
                    ref={inputRef}
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    className="py-2 w-24 sm:w-32 text-center px-2 font-bold rounded-lg text-base sm:text-lg focus:outline-none focus:ring focus:ring-slate-300 focus:border-slate-500 disabled:cursor-not-allowed"
                    onChange={handleChange}
                    value={displayValue}
                    disabled={disabled}
                    placeholder="0"
                    aria-labelledby="kmLabel"
                    aria-describedby="kmDescription"
                    role="spinbutton"
                    aria-valuenow={kilometers}
                />
                <div className="text-base sm:text-xl font-bold cursor-default">km</div>
                <div id="kmDescription" className="hidden">
                    Entrez le nombre de kilomètres parcourus à titre professionnel par an.
                </div>
            </div>
        </div>
    );
}